module.exports = __webpack_public_path__ + "img/login-barrionuevo.92aed2d1.svg";